import { ServerOption } from '../models/server-option';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { filterServerOption } from '../../select/shared/filter-server-option';
import { serverOptionActions } from './server-option.actions';

export const serverOptionFeatureKey = 'serverOptions';

export type ServerOptionState = EagerSelectState<ServerOption>;

const adapter = createEagerSelectAdapter<ServerOptionState, ServerOption>({
   featureKey: serverOptionFeatureKey,
   selectId: (server: ServerOption) => {
      return server.serverId;
   },
});

export const serverOptionSelectors = adapter.getSelectors(filterServerOption);

const initialState = adapter.getInitialState();

export const serverOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   serverOptionActions.search,
   serverOptionActions.searchReset,
   serverOptionActions.loadFromApi,
   serverOptionActions.loadFromApiSuccess,
   serverOptionActions.loadFromApiFailure
);
